<template>
  <div :class="'logo-block col-md-9 col-20 ' + addClass">
    <div class="title">
      {{ title }}
    </div>
    <a
      class="native-hash"
      :href="nativeHashLink"
      target="_blank"
    >
      <img
        :src="$publicPath + 'nativehash.svg'"
        width="251"
        height="143"
        class=""
      >
    </a>
    <div class="button-wrapper">
      <std-button
        :title="buttonTitle"
        :route-link="{ name: routeName }"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    addClass: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    buttonTitle: {
      type: String,
      default: ''
    },
    routeName: {
      type: String,
      default: 'register-step1'
    }
  },
  computed: {
    nativeHashLink () {
      return process.env.VUE_APP_NATIVEHASH_URL
    }
  }
}
</script>

<style scoped lang="scss">
  .logo-block {
    background: black;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    text-align: center;
  }
  a{
    margin: auto;
    padding: 4rem 1rem;
    box-sizing: content-box;
    img {
      max-width: 100%;
      max-height: auto;
    }
  }
  .title {
    color: white;
    margin-top: 4rem;
  }
  .button-wrapper {
    margin-bottom: 4rem;
  }
</style>
